export const getWashedLabel = (label: string) => {
  if (label) {
    return label.replace(/[\r\n]+/g, ' ').substring(0, 30)
  }
}
